import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { ArrowForward, Message } from '@mui/icons-material';
import getStyles from './styles';
import { useNavigate } from 'react-router-dom';

const OurProjectsContact = () => {
  const styles = getStyles();
  const navigate = useNavigate();

  return (
    <Box component="section" sx={styles.section}>
      <Container maxWidth="lg" sx={styles.container}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Box sx={styles.ctaCard}>
            {/* Animated background elements */}
            <Box sx={styles.backgroundContainer}>
              <Box
                component={motion.div}
                sx={styles.animatedCircle1}
                animate={{
                  scale: [1, 1.2, 1],
                  x: [0, 50, 0],
                  y: [0, 30, 0]
                }}
                transition={{
                  duration: 8,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }}
              />
              <Box
                component={motion.div}
                sx={styles.animatedCircle2}
                animate={{
                  scale: [1.2, 1, 1.2],
                  x: [0, -50, 0],
                  y: [0, -30, 0]
                }}
                transition={{
                  duration: 10,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }}
              />
              <Box sx={styles.gradientOverlay1} />
              <Box sx={styles.gradientOverlay2} />
            </Box>

            <Box sx={styles.content}>
              {/* <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <Box sx={styles.badge}>
                  <Box sx={styles.pulseDot} />
                  <Typography variant="body2" sx={styles.badgeText}>
                    Join 500+ Satisfied Clients
                  </Typography>
                </Box>
              </motion.div> */}

              <Typography variant="h2" sx={styles.title}>
                Empowering Innovation with
                <br />
                Amizhth Techno Solutions
              </Typography>

              <Typography variant="h3" sx={styles.subtitle}>
                From cutting-edge products to transformative digital services,
                we help businesses innovate, scale, and succeed in the modern
                world. Partner with us to build solutions that make an impact.
              </Typography>

              <Box sx={styles.buttonsContainer}>
                <Button
                  variant="contained"
                  size="large"
                  sx={styles.primaryButton}
                  startIcon={<Message sx={styles.buttonIcon} />}
                  endIcon={<ArrowForward sx={styles.buttonIcon} />}
                  onClick={() => navigate('/contact')}
                >
                  Let’s Work Together
                </Button>

                {/* <Button
                  variant="outlined"
                  size="large"
                  sx={styles.outlineButton}
                  startIcon={<CalendarToday sx={styles.buttonIcon} />}
                  onClick={() => navigate('/contact')}
                >
                  Schedule a Call
                </Button> */}
              </Box>

              {/* Trust badges */}
              {/* <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <Box sx={styles.trustBadges}>
                  <Box sx={styles.trustBadge}>
                    <Box sx={styles.checkCircle}>✓</Box>
                    <Typography variant="body2">
                      No Long-term Contracts
                    </Typography>
                  </Box>
                  <Box sx={styles.trustBadge}>
                    <Box sx={styles.checkCircle}>✓</Box>
                    <Typography variant="body2">Free Consultation</Typography>
                  </Box>
                  <Box sx={styles.trustBadge}>
                    <Box sx={styles.checkCircle}>✓</Box>
                    <Typography variant="body2">24/7 Support</Typography>
                  </Box>
                </Box>
              </motion.div> */}
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default OurProjectsContact;
